import { COLORS } from '../constants/colors';

export default function GlobalFooter() {

    const currentYear = new Date().getFullYear();
    return (
        <footer style={{ backgroundColor: COLORS.burgundy[900], color: COLORS.white, padding: '8px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%', flexWrap: 'wrap' }}>
                <p style={{ fontSize: "14px" }}>© {currentYear}&nbsp;
                    <a href="https://carlo-hildebrandt.de" target="_blank" rel="noopener noreferrer" style={{ color: COLORS.white, textDecoration: 'underline' }}>
                        Carlo Hildebrandt
                    </a>
                    &nbsp; All rights reserved.
                </p>
            </div >
        </footer >
    )
}
